import { inject, Injectable, Signal } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { UserStore } from '@shared/stores/user.store'; // Update the path accordingly

@Injectable({
  providedIn: 'root',
})
export class AccountManagerGuard implements CanActivate {
  // DI Services
  private readonly userStore = inject(UserStore);
  private readonly router: Router = inject(Router);

  // Properties
  isAccountManager$: Signal<boolean> = this.userStore.isAccountManager;

  // Actions
  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    const excludedRoutes: string[] = [
      '/profile/company-settings',
      '/profile/user-profile',
    ];

    const targetUrl = state.url.split('?')[0].split('#')[0];

    if (excludedRoutes.includes(targetUrl)) return true;
    if (!this.isAccountManager$()) return true;

    await this.router.navigate(['/profile/company-settings']);
    return false;
  }

  async canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    return this.canActivate(childRoute, state);
  }
}
